/**
 * Teknisyen Paneli - tech-person kullanıcılarının ana sayfası
 * Randevularım ve Randevu Test erişim kartları
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { sanitizeString } from '../utils/security';

const safeText = (v) => sanitizeString(v ?? '');

const TeknisyenPanelPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const ad = user?.ad || user?.adi || '';
  const soyad = user?.soyad || user?.soyadi || '';
  const displayName = [ad, soyad].filter(Boolean).join(' ') || user?.kullaniciAdi || 'Teknisyen';

  return (
    <div className="main-content-inner" style={{ padding: '24px', maxWidth: '800px' }}>
      <h1 style={{ marginBottom: '8px', fontSize: '1.5rem' }}>
        <i className="fas fa-tools" style={{ marginRight: '8px' }}></i>
        Teknisyen Paneli
      </h1>
      <p style={{ color: '#64748b', marginBottom: '24px' }}>
        Hoş geldiniz, {safeText(displayName)}. Aşağıdan randevularınıza veya Randevu Test sayfasına gidebilirsiniz.
      </p>

      <div style={{ display: 'grid', gap: '20px', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))' }}>
        <button
          type="button"
          onClick={() => navigate('/teknisyen/randevular')}
          style={{
            padding: '24px',
            border: '1px solid #e2e8f0',
            borderRadius: '12px',
            background: '#fff',
            cursor: 'pointer',
            textAlign: 'left',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            transition: 'box-shadow 0.2s, border-color 0.2s',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
            e.currentTarget.style.borderColor = '#2563eb';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06)';
            e.currentTarget.style.borderColor = '#e2e8f0';
          }}
        >
          <i className="fas fa-calendar-alt" style={{ fontSize: '1.5rem', color: '#2563eb', marginBottom: '12px', display: 'block' }}></i>
          <strong style={{ display: 'block', marginBottom: '4px' }}>Randevularım</strong>
          <span style={{ fontSize: '14px', color: '#64748b' }}>Atanan randevuları görüntüle ve yönet</span>
        </button>

        <button
          type="button"
          onClick={() => navigate('/teknisyen/randevu-test')}
          style={{
            padding: '24px',
            border: '1px solid #e2e8f0',
            borderRadius: '12px',
            background: '#fff',
            cursor: 'pointer',
            textAlign: 'left',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            transition: 'box-shadow 0.2s, border-color 0.2s',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
            e.currentTarget.style.borderColor = '#059669';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06)';
            e.currentTarget.style.borderColor = '#e2e8f0';
          }}
        >
          <i className="fas fa-vial" style={{ fontSize: '1.5rem', color: '#059669', marginBottom: '12px', display: 'block' }}></i>
          <strong style={{ display: 'block', marginBottom: '4px' }}>Randevu Test</strong>
          <span style={{ fontSize: '14px', color: '#64748b' }}>Tarayıcıdan randevu akışını test et</span>
        </button>
      </div>
    </div>
  );
};

export default TeknisyenPanelPage;
